import isElectron from 'is-electron';

const ipcRenderer = isElectron() ? require('electron').ipcRenderer : null;

export const getElectronLog = async (shouldClearLog) => {
    return new Promise((resolve, reject) => {
        ipcRenderer.once('get-log-result', (_event, log) => {
            if (!log) {
                resolve(null);
            }
            try {
                log = log.trim();
                // We have to remove the comma after the last log row to be able to parse the log
                log = JSON.parse(`[${log.substr(0, log.length - 1)}]`);
                resolve(log);
            } catch (error) {
                reject(error);
            }
        });
        ipcRenderer.send('get-log', shouldClearLog);
    });
};

export const clearElectronLog = () => {
    ipcRenderer.send('clear-log');
};

export const addElectronLogRow = (row) => {
    ipcRenderer.send('add-log-row', `${JSON.stringify(row)},`);
};
